import React from 'react';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { TrainerProfileDesktop } from './trainer-profile.desktop';
import { TrainerProfileMobile } from './trainer-profile.mobile';
import { PageProps } from 'gatsby';

export type TrainerData = {
  _id: string;
  name: string;
  first_name: string;
  last_name: string;
  summary: string;
  plan_id: string;
  bio: string;
  cover_image_url: string;
  profile_pic_url: string;
  available_spots: number;
  price: number;
  whatsapp_url: string;
  m_me_url: string;
  languages: Array<string>;
  certification: Array<{ cert_name: string; verification: boolean }>;
  intro_video?:string;
  intro_video_thumbnail?:string;
  trainer_number: number
};

interface Props extends PageProps {
  pageContext: {
    trainer: TrainerData;
  };
}

const TrainerProfileTemplate: React.FC<Props> = ({
  pageContext: { trainer },
  location
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  
  const content = isDesktop ? (
    <TrainerProfileDesktop location={location} trainerData={trainer} />
  ) : (
    <TrainerProfileMobile location={location} trainerData={trainer} />
  );
  return (
    <Layout>
      <SEO
        location={location}
        keywords={[
          `personal trainer`,
          `fitness coach`,
          `${trainer.first_name} ${trainer.last_name}`,
        ]}
        title={`${trainer.first_name}`}
        description={trainer.bio}
        image={trainer.profile_pic_url}
      />
      {content}
    </Layout>
  );
};

export default TrainerProfileTemplate;
